import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';
import { api } from '../../utils/api';

const I = {
  home:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  ops:        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="6" height="18"/><rect x="9" y="3" width="6" height="13"/><rect x="16" y="3" width="6" height="8"/></svg>,
  medals:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>,
  feed:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  ia:         <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>,
  ncm:        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  taxa:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  forn:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  perfil:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  chart:      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  alunos:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>,
  turmas:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  invite:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>,
  book:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  check:      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="20 6 9 17 4 12"/></svg>,
  notif:      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  logout:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  sos:        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  camera:     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  calc:       <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="11" x2="8" y2="11.01"/><line x1="12" y1="11" x2="12" y2="11.01"/><line x1="16" y1="11" x2="16" y2="11.01"/><line x1="8" y1="15" x2="8" y2="15.01"/><line x1="12" y1="15" x2="12" y2="15.01"/><line x1="16" y1="15" x2="16" y2="15.01"/><line x1="8" y1="19" x2="8" y2="19.01"/><line x1="12" y1="19" x2="12" y2="19.01"/><line x1="16" y1="19" x2="16" y2="19.01"/></svg>,
};

const BLUE = '#0057FF';
const NAV_ACTIVE_BG = 'rgba(0,87,255,.08)';
const NAV_ACTIVE_BORDER = BLUE;
const NAV_DEFAULT = 'transparent';

function Label({ children }) {
  return (
    <div style={{fontSize:9,fontWeight:700,color:'#94A3B8',letterSpacing:'.12em',textTransform:'uppercase',padding:'14px 18px 4px'}}>
      {children}
    </div>
  );
}

function Item({ to, icon, label, badge }) {
  const location = useLocation();
  const active = location.pathname === to || location.pathname.startsWith(to + '/');
  return (
    <NavLink to={to} style={{
      display:'flex', alignItems:'center', gap:10,
      padding:'9px 16px', margin:'1px 8px',
      borderRadius:10,
      color: active ? BLUE : '#5B6B85',
      background: active ? NAV_ACTIVE_BG : NAV_DEFAULT,
      borderLeft: active ? `2px solid ${NAV_ACTIVE_BORDER}` : '2px solid transparent',
      fontSize:13, fontWeight: active ? 600 : 400,
      textDecoration:'none', transition:'all .15s',
    }}
    onMouseEnter={e=>{ if(!active) e.currentTarget.style.background='rgba(0,87,255,.04)'; e.currentTarget.style.color=active?BLUE:'#334155'; }}
    onMouseLeave={e=>{ e.currentTarget.style.background=active?NAV_ACTIVE_BG:NAV_DEFAULT; e.currentTarget.style.color=active?BLUE:'#5B6B85'; }}>
      <span style={{color: active ? BLUE : '#94A3B8', display:'flex'}}>{icon}</span>
      <span style={{flex:1}}>{label}</span>
      {badge && <span style={{background:'#EF4444',color:'#fff',fontSize:9,fontWeight:700,padding:'2px 6px',borderRadius:99,minWidth:18,textAlign:'center'}}>{badge}</span>}
    </NavLink>
  );
}

// Item que abre uma ferramenta HTML fora da SPA (nova aba), ex: simulador de custos.
// Visual idêntico ao Item normal, mas usa <a> em vez de <NavLink> — não há rota React aqui.
function ItemExterno({ href, icon, label }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" style={{
      display:'flex', alignItems:'center', gap:10,
      padding:'9px 16px', margin:'1px 8px',
      borderRadius:10,
      color: '#5B6B85',
      background: NAV_DEFAULT,
      borderLeft: '2px solid transparent',
      fontSize:13, fontWeight: 400,
      textDecoration:'none', transition:'all .15s',
    }}
    onMouseEnter={e=>{ e.currentTarget.style.background='rgba(0,87,255,.04)'; e.currentTarget.style.color='#334155'; }}
    onMouseLeave={e=>{ e.currentTarget.style.background=NAV_DEFAULT; e.currentTarget.style.color='#5B6B85'; }}>
      <span style={{color: '#94A3B8', display:'flex'}}>{icon}</span>
      <span style={{flex:1}}>{label}</span>
      <span style={{color:'#B8C1D1',fontSize:10}}>↗</span>
    </a>
  );
}

export default function Sidebar({ notifCount }) {
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const initials = user?.nome?.split(' ').map(n=>n[0]).slice(0,2).join('').toUpperCase() || '?';
  const turmaLabel = user?.turma_nome || user?.turma || '';

  const chamarEmergencia = async () => {
    setEnviando(true);
    try {
      await api.post('/mentor/emergencia', {}, token);
      setEnviado(true); setTimeout(()=>setEnviado(false), 5000);
    } catch { alert('Erro ao enviar chamado'); }
    setEnviando(false);
  };

  return (
    <aside style={{
      width:240, background:'#fff', display:'flex', flexDirection:'column',
      height:'100vh', flexShrink:0,
      borderRight:'1px solid rgba(0,87,255,.08)',
      boxShadow:'2px 0 12px rgba(0,0,0,.03)',
    }}>
      {/* Logo */}
      <div style={{padding:'20px 20px 16px',borderBottom:'1px solid rgba(0,87,255,.06)'}}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <div style={{width:34,height:34,borderRadius:10,background:'linear-gradient(135deg,#0057FF,#003DB5)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
          </div>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:'#0F172A',letterSpacing:'-.01em'}}>Cockpit do</div>
            <div style={{fontSize:13,fontWeight:700,color:'#0057FF',letterSpacing:'-.01em'}}>Importador</div>
          </div>
        </div>
      </div>

      {/* Profile */}
      <div style={{padding:'14px 18px',borderBottom:'1px solid rgba(0,87,255,.06)',margin:'0 8px',marginBottom:4}}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <div style={{width:38,height:38,borderRadius:12,background:'linear-gradient(135deg,#EEF4FF,#DCE8FF)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:700,color:BLUE,flexShrink:0}}>
            {initials}
          </div>
          <div style={{minWidth:0}}>
            <div style={{fontSize:13,fontWeight:600,color:'#0F172A',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{user?.nome}</div>
            {turmaLabel && <div style={{fontSize:11,color:'#94A3B8',marginTop:1}}>{turmaLabel}</div>}
            {user?.role==='mentor' && <div style={{fontSize:10,fontWeight:600,color:BLUE,background:'rgba(0,87,255,.08)',padding:'1px 8px',borderRadius:99,marginTop:3,display:'inline-block'}}>Mentor</div>}
            {user?.role==='mentor_fornecedores' && <div style={{fontSize:10,fontWeight:600,color:BLUE,background:'rgba(0,87,255,.08)',padding:'1px 8px',borderRadius:99,marginTop:3,display:'inline-block'}}>Fornecedores</div>}
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{flex:1,overflowY:'auto',paddingTop:8,paddingBottom:8}}>
        {user?.role === 'mentor' ? (
          <>
            <Label>Visão geral</Label>
            <Item to="/mentor/dashboard"    icon={I.chart}   label="Dashboard" />
            <Item to="/mentor/alunos"       icon={I.alunos}  label="Alunos" />
            <Item to="/mentor/turmas"       icon={I.turmas}  label="Turmas" />
            <Item to="/mentor/convites"     icon={I.invite}  label="Convidar" />
            <Item to="/mentor/notificacoes" icon={I.notif}   label="Notificações" badge={notifCount > 0 ? notifCount : null} />
            <Label>Conteúdo</Label>
            <Item to="/mentor/materiais"    icon={I.book}    label="Biblioteca IA" />
            <Item to="/mentor/produtos"     icon={I.check}   label="Validador" />
            <Item to="/mentor/ncm"          icon={I.ncm}     label="Consulta NCM" />
            <Item to="/mentor/mercado-livre" icon={I.camera} label="Foto Mercado Livre" />
            <ItemExterno href="/ferramentas/simulador-custos.html" icon={I.calc} label="Custos Importação" />
            <Item to="/mentor/taxa-siscomex" icon={I.taxa}   label="Taxa Siscomex" />
            <Item to="/mentor/feed"         icon={I.feed}    label="Feed da Turma" />
            <Label>Base de Dados</Label>
            <Item to="/mentor/fornecedores"          icon={I.forn}  label="Dashboard" />
            <Item to="/mentor/fornecedores/lista"    icon={I.ops}   label="Fornecedores" />
            <Item to="/mentor/fornecedores/importar" icon={I.book}  label="Importar/Exportar" />
          </>
        ) : user?.role === 'mentor_fornecedores' ? (
          <>
            <Label>Base de Dados</Label>
            <Item to="/mentor/fornecedores"          icon={I.forn}  label="Dashboard" />
            <Item to="/mentor/fornecedores/lista"    icon={I.ops}   label="Fornecedores" />
            <Item to="/mentor/fornecedores/importar" icon={I.book}  label="Importar/Exportar" />
          </>
        ) : (
          <>
            <Label>Meu progresso</Label>
            <Item to="/dashboard"      icon={I.home}    label="Início" />
            <Item to="/operacoes"      icon={I.ops}     label="Minhas Operações" />
            <Item to="/conquistas"     icon={I.medals}  label="Conquistas" />
            <Label>Ferramentas</Label>
            <Item to="/ia"             icon={I.ia}      label="ImportBot IA" />
            <Item to="/ncm"            icon={I.ncm}     label="Consulta NCM" />
            <Item to="/taxa-siscomex"  icon={I.taxa}    label="Taxa Siscomex" />
            <Item to="/fornecedores"   icon={I.forn}    label="Fornecedores" />
            <ItemExterno href="/ferramentas/simulador-custos.html" icon={I.calc} label="Custos Importação" />
            <Label>Comunidade</Label>
            <Item to="/feed"           icon={I.feed}    label="Feed da Turma" badge={notifCount > 0 ? notifCount : null} />
            {user?.acesso_fornecedores_total && (
              <>
                <Label>Gestão de Fornecedores</Label>
                <Item to="/mentor/fornecedores"          icon={I.chart} label="Dashboard" />
                <Item to="/mentor/fornecedores/lista"    icon={I.forn}  label="Fornecedores" />
                <Item to="/mentor/fornecedores/importar" icon={I.book}  label="Importar/Exportar" />
              </>
            )}
            <Label>Conta</Label>
            <Item to="/perfil"         icon={I.perfil}  label="Meu Perfil" />
          </>
        )}
      </nav>

      {/* Emergência */}
      {user?.role === 'aluno' && (
        <div style={{padding:'10px 14px',borderTop:'1px solid rgba(0,87,255,.06)'}}>
          {enviado ? (
            <div style={{background:'rgba(34,197,94,.1)',border:'1px solid rgba(34,197,94,.2)',borderRadius:10,padding:'10px 14px',fontSize:12,color:'#16A34A',fontWeight:600,textAlign:'center'}}>
              ✓ Chamado enviado!
            </div>
          ) : (
            <button onClick={chamarEmergencia} disabled={enviando}
              style={{width:'100%',background:'rgba(239,68,68,.08)',border:'1px solid rgba(239,68,68,.2)',borderRadius:10,padding:'10px 14px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#DC2626',display:'flex',alignItems:'center',justifyContent:'center',gap:8,opacity:enviando?.7:1}}>
              {I.sos} {enviando ? 'Enviando...' : 'Emergência'}
            </button>
          )}
        </div>
      )}

      {/* Logout */}
      <div style={{padding:'10px 14px',borderTop:'1px solid rgba(0,87,255,.06)'}}>
        <button onClick={handleLogout} style={{display:'flex',alignItems:'center',gap:8,background:'transparent',border:'none',color:'#94A3B8',fontSize:12,cursor:'pointer',padding:'6px 4px',width:'100%',borderRadius:8,transition:'.15s'}}
          onMouseEnter={e=>{e.currentTarget.style.color='#5B6B85';e.currentTarget.style.background='rgba(0,0,0,.03)';}}
          onMouseLeave={e=>{e.currentTarget.style.color='#94A3B8';e.currentTarget.style.background='transparent';}}>
          {I.logout} Sair da conta
        </button>
      </div>
    </aside>
  );
}
